export default "__VITE_ASSET__l7sOV0Ly__"